import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { CabinetShelfRefDto, FiscalFileLocationDto, LandTitleDto, MeasureDto, MeasuringFactorDto, PurposeDto, RackTrayRefDto, StorageLocationDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-storage-location-table',
  templateUrl: './storage-location-table.component.html',
  styleUrls: ['./storage-location-table.component.scss']
})
export class StorageLocationTableComponent implements OnInit {

  @Input() selectedLandTitle: LandTitleDto;
  @Input() cabinetShelfRefs: CabinetShelfRefDto[];
  @Input() rackTrayRefs: RackTrayRefDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Output() emitEdit = new EventEmitter<StorageLocationDto[]>();

  storageLocationArrayForm: FormGroup;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
  this.storageLocationArrayForm = this.fb.group({StorageLocations: this.fb.array([])});
  if(this.selectedLandTitle.storageLocations != null && this.selectedLandTitle.storageLocations.length) {
    this.setFileLocation(this.selectedLandTitle.storageLocations);

  }
  }

  get storageLocationFormArray() {
    return this.storageLocationArrayForm.get('StorageLocations') as FormArray;
  }


  setFileLocation(storageLocations: StorageLocationDto[]) {
   storageLocations.forEach(storage => {
      this.storageLocationFormArray.push(this.fb.group({
        FileLocationId: storage.FileLocationId,
        CabinetShelfRefId: storage.CabinetShelfRefId,
        RackTrayRefId: storage.RackTrayRefId,
        FiscalFileRemarks: storage.FiscalFileRemarks,
        id: storage.id
      }));
    });
  }

  addStorageLocation(storage: StorageLocationDto) {
    this.storageLocationFormArray.insert(0, this.fb.group({
      FileLocationId: storage.FileLocationId,
        CabinetShelfRefId: storage.CabinetShelfRefId,
        RackTrayRefId: storage.RackTrayRefId,
        FiscalFileRemarks: storage.FiscalFileRemarks,
      IdentityRefId: storage.IdentityRefId,
    }));

  }

   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;

   getFileLocationName(id: string) {
     const found  = this.fileLocations.find( this.filterById(id, 'id'));
     return found ? found.FileLocationName : '';
   }

   getCabinetName(id: string) {
     const found = this.cabinetShelfRefs.find(this.filterById(id, 'id'));
     return found ? found.CabinetShelfRefNo : '';
   }

   getRackName(id: string) {
     const found = this.rackTrayRefs.find(this.filterById(id, 'id'));
     return found ? found.RackTrayRefNo : '';
   }

  onDelete(index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.storageLocationFormArray.removeAt(index);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }



}
